"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DefaultTitle = exports.DefaultMsg = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _reactResponsive = require("react-responsive");

var _styles = require("@material-ui/core/styles");

var _styles2 = require("../styles");

var _Typography = _interopRequireDefault(require("../Typography"));

var _Gate = _interopRequireDefault(require("../Gate"));

var _Grid = _interopRequireDefault(require("../Grid"));

var _Link = _interopRequireDefault(require("../Link"));

var _Spacing = _interopRequireDefault(require("../Spacing"));

var _Header = _interopRequireDefault(require("../Header"));

var _navigation = require("../utils/navigation");

var _links = require("../constants/links");

var Person = function Person(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", null, ".cls-1,.cls-14", "{", "fill:#eacba3", "}", ".cls-1", "{", "clip-rule:evenodd", "}", ".cls-2", "{", "fill:#f2f7ff;opacity:.95", "}", ".cls-3", "{", "fill:#e6ecf6", "}", ".cls-4", "{", "fill:#00ab61", "}", ".cls-5", "{", "fill:#33bb80", "}", ".cls-6", "{", "fill:#576380", "}", ".cls-7", "{", "fill:#515d7b", "}", ".cls-8", "{", "fill:#bccae1", "}", ".cls-25,.cls-27,.cls-9", "{", "fill:#2e6297", "}", ".cls-10", "{", "fill:#dfbd91", "}", ".cls-11", "{", "fill:#f79469", "}", ".cls-12,.cls-16", "{", "fill:#d3af81", "}", ".cls-13", "{", "fill:#fff", "}", ".cls-13,.cls-14,.cls-16,.cls-23", "{", "fill-rule:evenodd", "}", ".cls-15", "{", "clip-path:url(#clip-path)", "}", ".cls-17,.cls-23", "{", "fill:#212121", "}", ".cls-18", "{", "fill:#4175a9", "}", ".cls-19", "{", "fill:#4880b8", "}", ".cls-20", "{", "fill:#adc6ff", "}", ".cls-21", "{", "fill:#ffcf5d", "}", ".cls-22", "{", "fill:#a1bcf7", "}", ".cls-24", "{", "fill:#528dc8", "}", ".cls-24,.cls-25", "{", "opacity:.4", "}", ".cls-26", "{", "fill:#9aaac1", "}", ".cls-27", "{", "opacity:.5", "}"), /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M188.84 60.6c0 1.67 2.63 1.9 2.63 1.9s2.94-.28 2.92-1.91c0-3.17-1-5.94-2.32-6.15-1.47-.23-3.27 2.56-3.23 6.16z"
  }))), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-2",
    d: "M380.93 173a140.76 140.76 0 0 1-8.49 21.87c-.88 1.78-1.8 3.57-2.8 5.34-9.74 17.61-24.88 34.44-48.37 43.92-50.27 20.29-211.87 32.29-284.75-9.4a96.07 96.07 0 0 1-14-9.6 73.45 73.45 0 0 1-6.83-6.42C6.65 209 1.15 197.39.36 183.65-5.36 84.6 57.62 28.44 89.63 12.17s71.29-16.86 102 2.13c16 9.87 29.52 24.65 46.92 31 20.2 7.42 42.37 2.41 63.53 5.21 27.36 3.62 52 21.26 68.17 45.57 14.39 21.61 18.44 50.82 10.68 76.92z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-3",
    d: "M260.35 210c0 3.57-31.81 6.46-71.05 6.46s-71.05-2.89-71.05-6.46 31.81-6.46 71.05-6.46 71.05 2.9 71.05 6.46z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-4",
    d: "M110 202.68c-8.33-31.37-5.88-82.38-.95-97C114.38 89.71 121.65 81.32 122 81l2.27 2-1.14-1 1.14 1c-.08.08-7.25 8.39-12.41 23.81-4.76 14.23-6.44 67.91 3.8 95.86zM93.18 205.31c-.18-4.17-1.1-71.75-1.59-76.08-1.73-15.23-5.87-30.12-15.93-35.58C67.09 89 59.11 96.27 59 96.33l-2.82-6.13c.42-.25 10.35-6 20.4-.51 9.21 5 15.15 17.47 17.73 37.16.61 4.63 3.29 72.88 3.53 78.31z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-4",
    d: "M105.13 207.15l-5.86.39c5.06-38.12-4.57-64.91-9.25-67.78-3.45-2.11-6.94-1-9.26.33-4.93 2.79-8.33 8.43-8.3 11.75h-1.65c0-4.94 2.79-11.49 8.33-14.63 4.37-2.48 8.84-2.57 12.6-.27 9.26 5.71 14.8 38.57 13.39 70.21zM96.85 107.56q-1.35-2.39-2.62-5c-10.5-21.63 13.91-44 28.32-23.62 1.24 9.32 7 19.56 12.47 29.75 6.52 12.08 13.88 21.71 24.12 27.52a47 47 0 0 1-18.43 2.34c-1.46-4.71 1.31-16.89-2.91-16.35s.56 12.94 2 16.27a47.78 47.78 0 0 1-14.79-3.8c-.64-5.58 9.43-19.9 4-21.25-5.92-1.47-5.08 19.38-5 20.79-4.69-2.18-7.62-3.7-12-7.81-.64-12.77 14.91-23.47 8.58-26.55-7-3.41-11.42 23.93-11.42 23.93a70.48 70.48 0 0 1-11.3-14.64c6-11.33 22.2-18.62 16.49-23.11s-14.75 15.03-17.51 21.53z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-5",
    d: "M135 108.71c6.52 12.08 13.88 21.71 24.12 27.52l.39-.13c.32-4.38 1.76-10.09 3.44-18-5.46-2.36-15.2-4.65-13.49-8.39s10.25 2.46 14.52 5.88a72.2 72.2 0 0 0 1.39-9.27c-8.64-5.9-20.74-5.1-18.75-9.45s14 2.89 19 6.84c.28-5 .53-7.82-.76-12.92-10.64-4.63-27 .45-26.36-6.22s20.19.33 25.4 2.35a39.23 39.23 0 0 0-3.12-7.61c-11.43-21.16-38.24-23.48-38.19-.34 1.2 9.31 6.93 19.55 12.41 29.74zm-2.49-37.24c2.6-3.71 10.68.72 9.22 5s-14.73 2.84-9.2-5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-6",
    d: "M125.4 197.12c0 5-2.44 9.62-6.54 13.06h-3l-12.12.12h-1.43l-16.22.15h-3c-4.17-3.36-6.75-7.9-6.8-12.93-.06-6.16 3.7-11.66 9.54-15.19l-.35-35.94 6.29-.05 18.91-.19h4.57l.36 35.93c5.87 3.45 9.72 8.92 9.79 15.04z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-4",
    d: "M43.61 149.16c.43-1.24.92-2.5 1.45-3.79 6.64-15.92 30.26-13.42 26.15 4-4.42 5.1-7.21 13-10.07 20.84-3.4 9.25-5.08 17.78-3.34 26.05a33.85 33.85 0 0 1-10-8.8c1.84-3 9.7-7.32 7.4-9.34s-6.69 6.45-7.81 8.79a34.2 34.2 0 0 1-5-9.75c2.7-3 15.18-4.39 13.32-8-2-3.88-12.84 6.48-13.56 7.18a28 28 0 0 1-1.52-10.18c6.56-6.41 19.7-3.13 18.35-8-1.5-5.39-18.29 5.23-18.29 5.23a50.8 50.8 0 0 1 2.51-13c8.93-2.16 20.56 3.09 20.26-2.11s-15.04-.73-19.85.88z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-5",
    d: "M61.13 170.23c-3.4 9.25-5.08 17.78-3.34 26.05l.26.14c2.5-1.9 6.26-3.85 11.31-6.71-1.32-4.05-4.72-10.38-1.9-11.23s3.55 6.67 3.75 10.6a55.52 55.52 0 0 0 5.64-3.65c-.93-7.46-7.11-13.58-3.83-14.58s5.1 8.91 5.33 13.44c2.82-2.23 4.46-3.43 6.58-6.54-2.56-7.92-13.08-14.33-9.18-17.14s9.42 11 10.81 14.78a28.39 28.39 0 0 0 2.61-5.3c6-16.19-5.54-31.71-18-20.7-4.39 5.1-7.17 13.04-10.04 20.84z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-4",
    d: "M37.39 100.55C29.64 106.64 23.73 113 20.87 121c0 .09.09.18.14.27 3.13-.31 7.35 0 13.15.23 1-4.15 1.44-11.31 4.29-10.56s-.49 7.55-2.38 11a54.49 54.49 0 0 0 6.72-.15c3.12-6.83 1.08-15.29 4.4-14.41s-.34 10.26-2.53 14.23c3.57-.41 5.59-.58 9-2.11 2-8.08-3.61-19.06 1.19-19.4s2.23 14.32 1.43 18.25a28.5 28.5 0 0 0 5-3.13c13.57-10.66 11.95-29.9-4.41-27.06-6.4 1.97-12.95 7.26-19.48 12.39z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-7",
    d: "M125.4 197.12c0 5-2.44 9.62-6.54 13.06h-3l-12.12.12c9.26-4.3 12.66-12.3 6.9-26.14v-37.93h4.57l.36 35.93c5.91 3.37 9.76 8.84 9.83 14.96z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-8",
    d: "M66 223.85c-2-.65-4.43-1.81-5.08-3.71s.88-4.39 2.77-5.58c2.47-1.54 5.85-1.92 8.83-2.25a68 68 0 0 1 7.66-.57 21.1 21.1 0 0 1 7 1 11.53 11.53 0 0 1 6.3 5.28A28.67 28.67 0 0 1 66 223.85zm46.13-76.49a33.91 33.91 0 0 0 7.28-3.32l-3-4.65a29.65 29.65 0 0 1-6.15 2.76c-3.52 1.27-7.52 2.72-10.74 6.27A25 25 0 0 0 93.71 170a45.76 45.76 0 0 0 4.37 11 60.78 60.78 0 0 1 3.13 6.92 28.72 28.72 0 0 1-3.82 25.8 17.5 17.5 0 0 0-8.39-6.19c-5.73-2-11.77-1.32-17.09-.73-3.39.38-7.61.85-11.15 3.06-3.77 2.36-6.72 7.26-5.08 12.08 1.12 3.26 4 5.67 8.6 7.18a34.39 34.39 0 0 0 28.28-3.52 18.7 18.7 0 0 1-7.16 4.9c-10.54 4.32-23.74 4.54-40.36.67-4.8-1.12-9.67-2.48-14.38-3.8-2.69-.75-5.4-1.51-8.15-2.24a96.07 96.07 0 0 0 14 9.6c2.42.65 4.86 1.28 7.29 1.84 17.78 4.14 32.08 3.83 43.72-.94 7.22-3 11.69-7.82 12.25-13.32a11.5 11.5 0 0 0 0-2.69 34.31 34.31 0 0 0 6.68-33.53 63.52 63.52 0 0 0-3.41-7.57 41.31 41.31 0 0 1-3.89-9.67 19.27 19.27 0 0 1 4.51-16.7c2.34-2.54 5.17-3.58 8.51-4.79z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M276.48 122.27c-11.6 2.44-23-2.68-34.75 1.48-15.84 5.66-7.91 18-18.7 28-9.8 9.8-29.14 8.33-42.14 3.47-11.69-4.23-18.28-12.53-19.8-20.62-3.28-16.23 15.3-24.64 13-38.41-1.63-17.76-24.63-26.95-27.65-44-5.85-31.49 52.56-63.88 73.82-33.31 8.93 12.73 1 35.61 15.81 46.16 11.46 8.26 27.24 1 40.25 3.65a28.12 28.12 0 0 1 19.07 15.14c8.44 16.92-3.53 35.17-18.91 38.44z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-9",
    d: "M163.53 157.22s30.69 8.14 50.4.6c22 14.88 6.72 35.66-4 38.32s-41.59 4.78-49.91 3.68c-15.22-2-25.86-24.88 3.51-42.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-10",
    d: "M206.86 86c-4.4 5.94-10.28 11.73-16.48 11.86C181.82 98 176 89 173 83l3.32-.84c4.84-1.21 7.34-3.42 8.67-5.88a14.52 14.52 0 0 0 1.49-6c.09-1.23.1-2.35.21-3.25a15.51 15.51 0 0 1 8.23 1c-.23.87-.42 1.69-.56 2.47a21.21 21.21 0 0 0-.43 4.77c.3 7.66 6.12 9.36 12.93 10.73z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-11",
    d: "M194.94 68.07c-.23.86-.41 1.69-.56 2.46a22.83 22.83 0 0 0-.42 3.78 8.5 8.5 0 0 1-2.75.47 10.38 10.38 0 0 1-5.11-1.51 20.51 20.51 0 0 0 .4-3c.09-1.22.1-2.35.21-3.25a15.51 15.51 0 0 1 8.23 1.05z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-12",
    d: "M194.94 68.07c-.23.86-.41 1.69-.56 2.46a22.83 22.83 0 0 0-.42 3.78 8.5 8.5 0 0 1-2.75.47 10.38 10.38 0 0 1-5.11-1.51 20.51 20.51 0 0 0 .4-3c.09-1.22.1-2.35.21-3.25a15.51 15.51 0 0 1 8.23 1.05z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-10",
    d: "M211.1 48.72c-.32-2.55-2.38-1.47-3.28-.85 0-13-3.11-23.52-16.61-23.52s-16.54 10.37-16.62 23.25c-.8-.59-2.26-1.45-3-.43-.95 1.43-1.25 5.08 3.5 6.4 2.14 10.43 9.82 18.23 16.12 18.23s13.69-7.5 15.94-17.66c2.48.1 4.34-2.41 3.95-5.42z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "SMILE",
    className: "cls-13",
    d: "M187.67 65.69l7.06.17a.47.47 0 0 1 .42.66c-.55 1.2-1.64 2-3.69 2.17a4.37 4.37 0 0 1-4.2-2.28.47.47 0 0 1 .41-.72z"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "eyes_nose"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Nose"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-14",
    d: "M188.84 60.6c0 1.67 2.63 1.9 2.63 1.9s2.94-.28 2.92-1.91c0-3.17-1-5.94-2.32-6.15-1.47-.23-3.27 2.56-3.23 6.16z"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-16",
    d: "M189.15 56.35c-1.86 4.34 3.82 7 6.72 3.08l-.87 2.91-3.58 1.44-3.95-2.86z"
  }))), /*#__PURE__*/_react["default"].createElement("ellipse", {
    className: "cls-17",
    cx: "185.35",
    cy: "52.02",
    rx: "1.36",
    ry: "1.53",
    transform: "rotate(-85.58 185.35 52.02)"
  }), /*#__PURE__*/_react["default"].createElement("ellipse", {
    className: "cls-17",
    cx: "197.88",
    cy: "52.53",
    rx: "1.36",
    ry: "1.53",
    transform: "rotate(-85.58 197.88 52.526)"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-10",
    d: "M255.82 157.82a1.28 1.28 0 0 1 0-2.55c6.45-.12 10.78-9.29 10.82-9.38a1.27 1.27 0 0 1 2.31 1.07c-.2.44-5.06 10.71-13.08 10.86z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-10",
    d: "M257 157.86c-.42 0-.84 0-1.27-.05a1.27 1.27 0 1 1 .21-2.53c9.22.74 14.64-8.84 14.7-8.94a1.27 1.27 0 1 1 2.23 1.23c-.25.43-5.8 10.29-15.87 10.29z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-10",
    d: "M256.33 159.36a29.07 29.07 0 0 1-3.75-.24 1.27 1.27 0 1 1 .31-2.52c11.61 1.45 17.42-4.87 17.48-4.93a1.27 1.27 0 0 1 1.9 1.69c-.27.27-5.52 6-15.94 6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-10",
    d: "M252.25 157.71a1.19 1.19 0 0 1-.3-2.34c.11 0 7.25-2 9.7-7.78a1.19 1.19 0 0 1 2.19.93c-2.92 6.89-10.95 9.06-11.29 9.15a1 1 0 0 1-.3.04zM125.55 154.69a1.28 1.28 0 0 0 1.24-1c0-.22 1.2-5.42-1.1-8.67a6 6 0 0 0-4.38-2.47 1.27 1.27 0 0 0-.29 2.53 3.41 3.41 0 0 1 2.59 1.41c1.37 1.93 1 5.44.7 6.63a1.26 1.26 0 0 0 1 1.52 1.35 1.35 0 0 0 .24.05z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-10",
    d: "M122.76 155a1.25 1.25 0 0 0 1-.56 1.27 1.27 0 0 0-.34-1.76c-2.17-1.46-3.37-3-3.49-4.36a3.11 3.11 0 0 1 .91-2.35 1.27 1.27 0 0 0 .07-1.79 1.25 1.25 0 0 0-1.78-.09 5.72 5.72 0 0 0-1.74 4.38c.16 2.24 1.71 4.36 4.61 6.32a1.28 1.28 0 0 0 .76.21z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-10",
    d: "M125.12 154.68a1.27 1.27 0 0 0 0-2.54c-6.44-.12-10.78-9.29-10.82-9.38a1.27 1.27 0 0 0-2.31 1.07c.21.43 5.07 10.7 13.09 10.85z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-10",
    d: "M124 154.73h1.27a1.27 1.27 0 0 0-.2-2.54c-9.23.75-14.65-8.83-14.7-8.93a1.27 1.27 0 0 0-2.23 1.23c.19.39 5.74 10.24 15.86 10.24z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-10",
    d: "M124.62 156.23a29.29 29.29 0 0 0 3.75-.24 1.27 1.27 0 0 0-.32-2.52c-11.61 1.44-17.42-4.87-17.48-4.94a1.27 1.27 0 0 0-1.89 1.7c.24.27 5.51 6 15.94 6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-18",
    d: "M246.06 197.5c-1.07.95-2.21 1.9-3.44 2.85-28.69 19.9-75.57 8.14-84.07 2.23-3.53-1.56-2.81-7.47-1.71-9.76 4.19-.12 13.86 1 35.25-10.16a222.28 222.28 0 0 0 20.84-12.58c36.38-24.52 45.68-5 46.1 3.08.32 6.15-2.74 15.23-12.97 24.34z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-9",
    d: "M246.06 197.5c-1.07.95-2.21 1.9-3.44 2.85-28.69 19.9-75.57 8.14-84.07 2.23-3.53-1.56-2.81-7.47-1.71-9.76 4.19-.12 13.86 1 35.25-10.16a25.29 25.29 0 0 0 2.09 2.18 28.49 28.49 0 0 0 7.35 5 27.18 27.18 0 0 0 9.35 2.52c5.22.43 10.42-.63 15.63-1.12s10.74-.33 15.27 2.28a13.37 13.37 0 0 1 4.28 3.98z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M242.78 199.81c1.05 3.15-4.61 7.86-12.64 10.52s-15.37 2.26-16.42-.89 4.61-7.87 12.64-10.53 15.38-2.26 16.42.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-10",
    d: "M234.37 202.59c.65 2-2.91 5-8 6.63s-9.68 1.42-10.34-.57 2.9-5 7.95-6.62 9.73-1.42 10.39.56z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M132.24 206.57c-.75-3.24 5.32-7.41 13.56-9.32s15.52-.82 16.27 2.42-5.32 7.41-13.56 9.31-15.51.82-16.27-2.41z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-10",
    d: "M140.88 204.57c-.47-2 3.35-4.66 8.53-5.86s9.77-.52 10.24 1.52-3.35 4.66-8.53 5.86-9.77.52-10.24-1.52z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-19",
    d: "M122.65 170.3c1.41-8 13-26.21 46.14 2.57s47.58 28.61 52.89 29.42c.8 2.41.8 8.36-2.9 9.48-9.16 4.82-57.12 10.77-83.16-12.48C124 187.75 121.47 177 122.65 170.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-18",
    d: "M221.54 208.92a4.36 4.36 0 0 1-2.76 2.85c-9.16 4.83-57.12 10.77-83.17-12.48-11.66-11.54-14.14-22.29-13-29a16.74 16.74 0 0 1 6.4-10.23 16.94 16.94 0 0 0-3.28 7.2c-1.19 6.7 1.3 17.45 13 29 25.72 22.95 72.8 17.44 82.81 12.66z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-20",
    d: "M257.44 159.37c-4.51 1.36-33.79 14.24-43.3-9.42-.13-.32-.26-.66-.38-1a4.91 4.91 0 0 1-.17-.5c-.05-.12-.09-.24-.13-.37-2-16.15-2.88-27.66-2.88-27.66L206.86 86h.08l.37.07.67.14c5.94 1.33 29.61 9.5 18.85 56.31 8.82 2.23 14.53 9.26 18.54 11.16a17.1 17.1 0 0 0 8.55 1.68s2.79.35 3.52 4.01zM123.5 156.24c4.5 1.37 33.79 14.25 43.3-9.41.13-.33.25-.66.38-1a4 4 0 0 0 .16-.49c.06-.12.09-.24.14-.37 1.94-16.16 2.87-27.66 2.87-27.66l3.73-34.48H174l-.37.07-.63.1c-5.94 1.33-29.62 9.51-18.86 56.32-8.82 2.23-14.52 9.26-18.54 11.16a17.07 17.07 0 0 1-8.54 1.68s-2.84.43-3.56 4.08z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-20",
    d: "M174.06 82.82s7.26 13 15.88 13.31 16.25-10.32 16.25-10.32a14.27 14.27 0 0 1 5.65 1.58c3.14 1.57 8.62 21.39 7.69 32s-10.81 11.65-10.81 11.65-2.76 19.48 5.66 27.07c-13.95 2.84-19.92 9.71-50.85-.9 2.61-5.05 8.65-21.33 9.49-26.64-5.21-.64-18.14-8.57 1.04-47.75z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-21",
    d: "M214.37 158.13c-14 2.84-19.91 9.71-50.85-.91 2.61-5.05 8.65-21.32 9.5-26.63a9.22 9.22 0 0 1-5.37-2.85 1.4 1.4 0 0 1 .18-.32c1.38-1.91 4.6 1.07 6.31 1.59a13.74 13.74 0 0 0 9.21-.4c-2.11 4.09-3.95 8.69-3 13.2s4.9 8.33 9.41 9.83 9.48 1 14-.4a43 43 0 0 0 5.68-2.3 17.94 17.94 0 0 0 4.93 9.19z"
  }), /*#__PURE__*/_react["default"].createElement("ellipse", {
    cx: "191.11",
    cy: "33.39",
    rx: "23.06",
    ry: "12.02"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-22",
    d: "M189.52 130.37a53.64 53.64 0 0 0 12.08 2.31 16.92 16.92 0 0 0 6.77-1 10.13 10.13 0 0 0 5.28-4.57 15.27 15.27 0 0 0 1.71-6.43 31.6 31.6 0 0 0-.28-6.39 72.23 72.23 0 0 0-3-12.23A72 72 0 0 1 214 114.4a31 31 0 0 1-.27 6.11 13.54 13.54 0 0 1-2 5.44 7.56 7.56 0 0 1-4.29 3.1 14 14 0 0 1-5.6.28 33.27 33.27 0 0 1-5.78-1.33c-1.93-.6-3.79-1.33-5.84-2.07h-.16a1.88 1.88 0 0 0-1.1 0 38.7 38.7 0 0 1-12.24 2.29 13.06 13.06 0 0 1-5.69-1.26 8.68 8.68 0 0 1-3.92-4.08 16.28 16.28 0 0 1-1.39-6 33.78 33.78 0 0 1 .31-6.42 59.37 59.37 0 0 1 3.31-12.63 60.42 60.42 0 0 0-4.41 12.43 34.12 34.12 0 0 0-.89 6.64 18.09 18.09 0 0 0 1 6.85 11.19 11.19 0 0 0 4.58 5.62 13.59 13.59 0 0 0 3.33 1.49c-1 5.56-6.89 21.4-9.46 26.37 30.94 10.62 36.9 3.75 50.85.91a17.94 17.94 0 0 1-4.93-9.19 43 43 0 0 1-5.68 2.3c-4.53 1.43-9.5 1.89-14 .4s-8.44-5.18-9.41-9.83c-.71-3.45.19-6.95 1.6-10.23a54.41 54.41 0 0 0 7.6-1.22z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Eyebrow_Left",
    className: "cls-23",
    d: "M203.58 49.48a2 2 0 0 0-.8-1c-.47-.34-3-.33-4.37-.44-.55 0-1.36-.08-2-.1a.5.5 0 0 0-.27.07.46.46 0 0 0 .07.81c1.25.54 3.45.32 5.65.11a1.24 1.24 0 0 1 .74.15c.76.6.52.59.88.67.16.06.1-.27.1-.27z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Eyebrow_Left-2",
    className: "cls-23",
    d: "M181.57 49.26c.37 0 .13-.07.93-.61a1.18 1.18 0 0 1 .75-.1c2.17.36 4.35.73 5.64.27A.46.46 0 0 0 189 48a.45.45 0 0 0-.26-.08h-2c-1.39 0-3.9-.17-4.39.14a2.07 2.07 0 0 0-.87.92s-.06.3.09.28z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-8",
    d: "M351.58 191.32c-4.72-1.31-9.46-3-14.05-4.6-5.23-1.85-10.65-3.76-16.17-5.19a73 73 0 0 0-11.79-2.11c-11.68-19.25-31.61-33.34-54-37.09l-.92 5.46c19.25 3.23 37 15.21 48.1 31.41a41.29 41.29 0 0 0-14.27 2.85c-10.76 4.35-18.91 14.2-20.74 25.09-2 11.66 3.47 23.86 13.21 29.67a25.76 25.76 0 0 0 13.22 3.56 25.23 25.23 0 0 0 18.78-8c7-7.78 8.73-20.22 4.85-34.13a74.09 74.09 0 0 0-4.92-12.85 72.38 72.38 0 0 1 7.12 1.48c5.29 1.37 10.59 3.24 15.71 5.06 4.68 1.65 9.51 3.35 14.41 4.71a108.94 108.94 0 0 0 19.55 3.53c1-1.77 1.92-3.56 2.8-5.34a103.75 103.75 0 0 1-20.89-3.51zm-42.79 37.37c-5.89 6.58-17.12 8.08-25 3.36-7.7-4.6-12.15-14.68-10.59-24 1.53-9 8.34-17.22 17.36-20.87a36.71 36.71 0 0 1 13.82-2.48h1.83a67.87 67.87 0 0 1 6.25 15c1.54 5.75 4.4 19.98-3.67 28.99z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-18",
    d: "M144.86 143.94c0 2.88-.63 4.93-2 5.65l-5.6 2.53c-1.9.86-4.71-.79-7.62-4.1-8.81-10.09-14.67-30.36-9.11-32.87 0 0 3.87-2 5.39-2.45 6.91-3.12 19.36 20.93 18.94 31.24z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-18",
    d: "M129.65 148c-8.61 4.73-19.12-.57-20.32-9.55a14.14 14.14 0 0 1 9.26-14.89c.96 7.54 5.57 18.16 11.06 24.44z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-24",
    d: "M132.59 115.68v.15s-9.68-10.67-8.25 6.77c.92 6.05-3.15 10.53-4.4 6.62l-.07.05c-.24.73 1 8.37-10.5 9.19a14.14 14.14 0 0 1 9.26-14.89c-.57-4.38 0-7.57 1.93-8.43 0 0 3.86-2 5.38-2.44a.36.36 0 0 0 .09 0c1.64-.8 4.02.4 6.56 2.98z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-9",
    d: "M131.7 126.57c-1.37.62-3.57-4.25-2.2-4.87s3.58 4.3 2.2 4.87zM138.19 138.14c1.46 3.22-.6 4.2-2.07.94s.6-4.19 2.07-.94z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-25",
    d: "M135.39 119c3.68 6.6 7.47 14.95 8 22.54 1.16 17.5-14.42-1.69-18.17-17.74a43.84 43.84 0 0 0 5.15 15.63c-.57 1.68-2.79 3.3-4.77 2.45-4.44 7.33-13.15 4.06-15.32 0v.1c3.28 7.26 12.39 9.78 19.29 6 2.9 3.31 5.7 5 7.6 4.11L142 150c5.59-1.41 3.49-17.42-6.61-31z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-8",
    d: "M246.4 128.11c-.65 1.06-1.28 2.2-1.9 3.4l-2.57-1.06a1.93 1.93 0 0 1 1.46-3.57zM239.32 146.56l-3.43-1.41a1.92 1.92 0 0 1-1-2.51 1.94 1.94 0 0 1 2.52-1l2.8 1.15c-.4 1.27-.69 2.55-.89 3.77z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-26",
    d: "M240.16 142.73l-1.09-.45c0 .09-.46 1.42-.94 3.79l1.19.49c.2-1.22.49-2.5.84-3.83zm6.24-14.62l-.77-.31c-.83 1.24-1.6 2.68-2 3.36l.86.35c.63-1.2 1.26-2.34 1.91-3.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-18",
    d: "M264.32 132.1c.25-2.9.23-8.22-2.47-9.34-.68-.38-6.05-2.69-6.58-2.47-5.34-.12-11.38 11.14-13.6 16.55a58.33 58.33 0 0 0-2.33 6.85 41.64 41.64 0 0 0-1.19 6.34c-.48 5.07.85 7.15.89 7.3.78 1.36 1.63 1.47 4 2.44l3.46 1c1.93.61 4.69-1.39 7.39-4.71 14.11 2.55 22.55-15.06 10.43-23.96z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-18",
    d: "M250.05 154.78C248.7 137.26 260.2 130 260.24 130a14.87 14.87 0 0 1 7.35 5.47c8.27 12.45-5.46 25.39-17.54 19.31z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-24",
    d: "M263.93 125.61c-5.63-4.56-9.7 3.82-11.28 5.82-1.83 2.32-3.78 2.59-5.44 1.86a4.33 4.33 0 0 1-2.43-2.87c2-3.48 6.49-10.22 10.49-10.13 1.48 0 6.3 2.16 6.65 2.36a4.7 4.7 0 0 1 2.01 2.96z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-27",
    d: "M269.25 147.75a12.92 12.92 0 0 1-14.25 1.87 6.24 6.24 0 0 1-3.37-7.76 24.41 24.41 0 0 1 7.35-11c-7.54 4.11-10.13 15.69-10.14 15.75-3.87.42-2.69-3.51-2.69-3.51a14.3 14.3 0 0 1-5.92-2.42c-4.13 12.07-1.2 16.52-1.2 16.61 1 1.72 2.13 1.47 7.24 3.76 2.51 1 6.18-3 7.91-5a13.59 13.59 0 0 0 15-8.34z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-10",
    d: "M258.92 159.34a1.19 1.19 0 0 1-.35-2.32 7.26 7.26 0 0 0 3.89-3.08 5.54 5.54 0 0 0 .08-4.38 1.19 1.19 0 0 1 2.25-.77 7.8 7.8 0 0 1-.23 6.26 9.51 9.51 0 0 1-5.31 4.24 1.26 1.26 0 0 1-.33.05z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-12",
    d: "M172.73 50.66c0 1.42.78 1.61 1.25.76a2.24 2.24 0 0 0 .17-1.55 5.62 5.62 0 0 0-.33-.94c-.41-.94-1.44-.87-1.85.16a2.1 2.1 0 0 0-.14.92c0 .3.29.39.44.15l.37-.77c.05-.15.2-.1.19 0zM209.35 51c0 1.43-.78 1.62-1.24.77a2.16 2.16 0 0 1-.17-1.56 7.28 7.28 0 0 1 .32-.94c.41-.93 1.45-.87 1.86.16a2.12 2.12 0 0 1 .13.92c0 .3-.29.4-.43.15l-.38-.77c-.05-.14-.2-.1-.18.06z"
  }))));
};

Person.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384.81 262.68"
};

var styles = function styles(theme) {
  return {
    pageWrapper: {
      background: theme.palette.common.white,
      maxWidth: theme.spacing(160),
      margin: '0 auto'
    },
    container: {
      padding: function padding(props) {
        return props.isMobile ? theme.spacing(4, 2) : theme.spacing(28, 8, 20, 9);
      }
    },
    mediaAsset: {
      margin: theme.spacing(3, 0, 0)
    }
  };
};

var msgStyles = function msgStyles(theme) {
  return {
    linkText: {
      display: 'inline-block',
      color: theme.palette.primary.main,
      '&:hover': {
        cursor: 'pointer'
      }
    }
  };
};

var onClick = function onClick(loc) {
  return function () {
    return (0, _navigation.redirect)(loc);
  };
};

var useStyles = (0, _styles2.makeStyles)(styles);
var useMsgStyles = (0, _styles2.makeStyles)(msgStyles);

var DefaultMsg = function DefaultMsg() {
  var classes = useMsgStyles();
  return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body1"
  }, "We've searched everywhere and cannot find the page you're trying to reach. But we'll figure this out together! Contact us at", ' ', /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    "data-qa": "contact-us-button",
    onClick: onClick("tel:".concat(_links.SUPPORT_PHONE)),
    className: classes.linkText
  }, _links.SUPPORT_PHONE), " or email us at ", /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    "data-qa": "email-us-button",
    onClick: onClick("mailto:".concat(_links.SUPPORT_EMAIL)),
    className: classes.linkText
  }, _links.SUPPORT_EMAIL), ".");
};

exports.DefaultMsg = DefaultMsg;

var DefaultTitle = function DefaultTitle() {
  var theme = (0, _styles.useTheme)();
  var isMobile = (0, _reactResponsive.useMediaQuery)({
    maxWidth: theme.breakpoints.values.md
  });
  return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    component: "h1",
    variant: isMobile ? 'h5' : 'h2'
  }, "Oh, that didn't work!");
};

exports.DefaultTitle = DefaultTitle;

var ErrorScreen = function ErrorScreen(_ref) {
  var header = _ref.header,
      title = _ref.title,
      message = _ref.message,
      actions = _ref.actions;
  var theme = (0, _styles.useTheme)();
  var isMobile = (0, _reactResponsive.useMediaQuery)({
    maxWidth: theme.breakpoints.values.md
  });
  var classes = useStyles({
    isMobile: isMobile
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.pageWrapper
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, null, header)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    container: true,
    alignItems: "center",
    className: classes.container
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement(_Spacing["default"], {
    marginRight: isMobile ? 2 : 6.25
  }, title), /*#__PURE__*/_react["default"].createElement(_Spacing["default"], {
    marginTop: isMobile ? 2 : 5,
    marginRight: isMobile ? 2 : 6.25
  }, message), /*#__PURE__*/_react["default"].createElement(_Gate["default"], {
    condition: actions && 0 < actions.length
  }, /*#__PURE__*/_react["default"].createElement(_Spacing["default"], {
    marginTop: isMobile ? 2 : 3,
    "data-qa": "actions"
  }, actions.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: "action-".concat(i)
    }, item);
  })))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.mediaAsset
  }, /*#__PURE__*/_react["default"].createElement(Person, null))))));
};

ErrorScreen.propTypes = {
  actions: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].element])),
  message: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].element]),
  header: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].element]),
  title: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].element])
};
ErrorScreen.defaultProps = {
  actions: [],
  message: /*#__PURE__*/_react["default"].createElement(DefaultMsg, null),
  header: /*#__PURE__*/_react["default"].createElement(_Header["default"], null),
  title: /*#__PURE__*/_react["default"].createElement(DefaultTitle, null)
};
var _default = ErrorScreen;
exports["default"] = _default;